import React from "react";
import { useTranslation } from "react-i18next";
import PageWrapper from "../pageWrapper";

//CSS
import "./ActivityPage.css";
import "../0PageStyles.css";

//Components
import ActivityView from "../../Components/Data Components/ActivityView";
import Button from "../../Components/Other Components/button";

//Functions and hooks

export default function ActivityPage() {
  const { t } = useTranslation();

  const tutorialSteps = [
    {
      target: null,
      title: t("Your activity log", { ns: "tutorial" }),
      message: t(
        "This is your Activity page - a running log of every significant action taken in your company's account, like who created, edited, or deleted what and when.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".search-bar-container",
      title: t("Search", { ns: "tutorial" }),
      message: t(
        "Search the log by username, action, object type, or detail.",
        { ns: "tutorial" }
      ),
    },
    {
      target: ".activity-card-container",
      title: t("Activity entries", { ns: "tutorial" }),
      message: t(
        "Each entry shows who did what, to which object, and when.",
        { ns: "tutorial" }
      ),
    },
    {
      target: "activity-show-more-btn",
      title: t("Show more", { ns: "tutorial" }),
      message: t(
        "The log loads a page at a time - click here to load older entries.",
        { ns: "tutorial" }
      ),
    },
  ];

  return (
    <PageWrapper tutorialId="activity" tutorialSteps={tutorialSteps}>
      <div className="page-content h-100">
        <div className="view-page-container h-100">
          <ActivityView />
        </div>
      </div>
    </PageWrapper>
  );
}
